export const CREATE_RA_STEPS = ['createRa.stepper.customerData', 'createRa.stepper.checkDriversValidity',
	'createRa.stepper.otpValidation',  'createRa.stepper.raFilling', 'createRa.stepper.preAuth', 'createRa.stepper.preview'];
export const RECOVERY_CREATE_RA_STEPS = ['createRa.stepper.customerData', 'createRa.stepper.checkDriversValidity',
	'createRa.stepper.otpValidation',  'createRa.stepper.raFilling', 'createRa.stepper.consentMgmt','createRa.stepper.preAuth', 'createRa.stepper.preview'];
export const CREATE_RA_STEPS_KEYLESS = ['createRa.stepper.customerData', 'createRa.stepper.checkDriversValidity',
	'createRa.stepper.raFilling', 'createRa.stepper.preAuth', 'createRa.stepper.preview'];
export const RECOVERY_CREATE_RA_STEPS_KEYLESS = ['createRa.stepper.customerData', 'createRa.stepper.checkDriversValidity',
	'createRa.stepper.raFilling', 'createRa.stepper.consentMgmt','createRa.stepper.preAuth', 'createRa.stepper.preview'];

// export enum ALL_STEPS {
// 	CUSTOMER_DATA = "createRa.stepper.customerData",
// 	CHECK_DRIVERS_VALIDITY = "createRa.stepper.checkDriversValidity",
// 	OTP_VALIDATION = "createRa.stepper.otpValidation",
// 	RA_FILLING = "createRa.stepper.raFilling",
// 	CONSENT_MGMT = "createRa.stepper.consentMgmt",
// 	PRE_AUTH = "createRa.stepper.preAuth",
// 	PREVIEW_AND_SIGNING = "createRa.stepper.preview"
// }

export const LANGUAGES = ['it', 'en', 'fr'];

export enum LOCALES {
	it = "it-IT",
	en = "en-IN",
	fr = "fr-FR"
}

export const GENDER_LIST = [{description: "Maschio", code: "M"}, {description: "Femmina", code: "F"}];

export const ELECTRIC_ENGINE_POWER_CODE = ['Electric', 'Hybrid', 'Hybrid Gasoline', 'Hybrid Diesel'];

export const TERMIC_HYBRID_ENGINE_POWER_CODE = ['Termic Diesel', 'Termic LPG', 'Termic Gasoline', 'Hybrid', 'Hybrid Gasoline', 'Hybrid Diesel'];

export const FILE_SIZE_LIMIT = {
	five: 5242880,
	ten: 10485760
}

export const LIQUID_MEASUREMENT_UNITS = 'l';
export const ELECTRIC_MEASUREMENT_UNITS = 'kWh';
export const LOCALE_DATE_FORMAT = 'YYYY-MM-DD';
export const LOCALE_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm';
export const LOCALE_DATE_TIME_HUMAN_FORMAT = 'YYYY-MM-DD HH:mm';
export const LOCALE_ISO_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';
export const DENOMINATOR = 8;

export const POLLING_INTERVAL_MS = 10000;
export const GRID_LIST_PAGE_SIZE = 25;
export const GRID_CACHE_BLOCK_SIZE = 25;
export const MAX_CHAR_BODY_NOTE = 250;
export const CREDIT_TYPE_LABELS = {
	STANDARD_CREDIT: 	'Standard Credit',
	FULL_CREDIT: 		'Full Credit',
	NO_CREDIT: 			'No Credit'
}

export const CREDIT_TYPE_LIST = ['STANDARD_CREDIT', 'FULL_CREDIT', 'NO_CREDIT'];

export const FINANCIAL_CREDIT_TYPES = {
	fullCredit: "FULL_CREDIT",
	noCredit: "NO_CREDIT",
	partialCredit: "PARTIAL_CREDIT"
}

export enum FinancialCreditType {
	fullCredit = "FULL_CREDIT",
	noCredit = "NO_CREDIT",
	partialCredit = "PARTIAL_CREDIT",
	standardCredit = "STANDARD_CREDIT"
}

export enum SegmentCode {
	replacement = "REP",
	corporate = "COR",
	tourOperator = "TOP",
	retail = "RET",
	subscription = "SUB",
}

export enum RENTAL_TYPES {
	RETAIL = 'RET',
	CORPORATE = 'COR',
}

export enum SEGMENTS {
	RETAIL = 'RET',
	SUBSCRIPTION = 'SUB',
}

export const FINANCIAL_PAYMENT_TIMING_CODES: string[] = ["1", "2", "3"];

export const FINANCIAL_PAYMENT_TIMING: any = {
	prepaid: "1",
	poa: "2",
	PAYONRETURN: "3",
	"1": "PREPAID",
	"2": "POA",
	"3": "PAY_ON_RETURN"
}

export enum BILLING_OWNER_TYPE {
	PERSON= 'PERSON',
	VAT_NUMBER= 'VAT_NUMBER',
	COMPANY= 'COMPANY'
}

export const EXTRA_SERVICES_LIST = [
	{
		"id": 0,
		"dealer": "string",
		"idPrcAncillary": 0,
		"ancillaryDescr": "Ancillary A",
		"ancillaryType": "string",
		"ancillaryPrice": 100,
		"ancillaryCount": 0,
		"ancillaryCode": "string",
		"ancillaryLabel":  "Ancillary A",
		"ancillaryMileage": "string",
		"ancillaryUnits": 0,
		"createdOperator": "string",
		"updatedOperator": "string",
		"selected": true
	},
	{
		"id": 0,
		"dealer": "string",
		"idPrcAncillary": 0,
		"ancillaryDescr":  "Ancillary B",
		"ancillaryType": "string",
		"ancillaryPrice": 200,
		"ancillaryCount": 0,
		"ancillaryCode": "string",
		"ancillaryLabel": "Ancillary B",
		"ancillaryMileage": "string",
		"ancillaryUnits": 0,
		"createdOperator": "string",
		"updatedOperator": "string",
		"selected": true
	},
	{
		"id": 0,
		"dealer": "string",
		"idPrcAncillary": 0,
		"ancillaryDescr": "Ancillary C",
		"ancillaryType": "string",
		"ancillaryPrice": 300,
		"ancillaryCount": 0,
		"ancillaryCode": "string",
		"ancillaryLabel": "Ancillary C",
		"ancillaryMileage": "string",
		"ancillaryUnits": 0,
		"createdOperator": "string",
		"updatedOperator": "string",
		"selected": false
	}
];


export const DEFAULT_HTTP_RESPONSE_STATE = {
	data: null,
	loading: false,
	error: ''
}

export const ITALY_CODE = 'IT';
export const FRANCE_CODE = 'FR';

export const FISCAL_CODE_REG_EXP = /^(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i;

export const regexList = {
    email: /^^.{1,}@.{1,}\..{1,}$/,
    fiscalCode: /^([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})$/,
	driverLicense: /^([A-Z]{2}\d{7}[A-Z])|(^[U]1[BCDEFGHLMNPRSTUWYXZ]\w{6}[A-Z])$/,
	vatNumber: /^[0-9]{11}$/
}

export enum COMPANY_CODES {
	DITTA_INDIVIDUALE="I1",
	S_N_C= "I2",
	S_A_S= "I3",
	SOC_DI_FATTO= "I4",
	SPA= "I5",
	SRL= "I6",
	SOC_CONSORTILE= "I7",
	COOPERATIVE= "I8",
	ONLUS= "I9",
	SAPA= "IA",
	ENTE_PUBBLICO= "IB",
	SOCIETA_ESTERA= "IC",
	ASSOCIAZ_PROFESS= "ID",
	COMM_EREDITARIA= "IE",
	ENTE_RELIGIOSO= "IF",
	ENTE_MORALE2= "IG",
	ENTE_OSP_ASL= "IH",
	ALTRI_ENTI= "IJ",
	FONDAZIONE= "IK",
	MUTUA_ASSICURAZ= "IL",
	SOCIETA_ANONIMA= "IM",
	SOC_COOP_AZIONI= "IN",
	SOC_COOP_ILLIM= "IO",
	SOC_COOP_LIMIT= "IP",
	SOC_SEMPLICE= "IQ",
	SRLS= "IR",
	SRLCR2= "IS",
	ALTRE_FORME_GIU= "ZZ",
	SPA_01= "01",
	SRL_02= "02",
	SAA_03= "03",
	SAS_04= "04",
	SRL_E_CO_SAS_05= "05",
	SOCDIRCIVILE_07= "07",
	CO_LTD_08= "08"
	}

export const COMPANY_WITHOUT_VAT_NR =
[
	COMPANY_CODES.SOCIETA_ESTERA,
	COMPANY_CODES.ENTE_OSP_ASL,
	COMPANY_CODES.SOCIETA_ANONIMA,
	COMPANY_CODES.ONLUS,
	COMPANY_CODES.ALTRE_FORME_GIU,
	COMPANY_CODES.ENTE_PUBBLICO,
	COMPANY_CODES.ENTE_RELIGIOSO,
	COMPANY_CODES.ENTE_MORALE2,
	COMPANY_CODES.ALTRI_ENTI,
];
